module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "bodytextm"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _vm._v("“Marley, if I were to be interviewed, my answers would look like I’ve had a ‘just right’ life.”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“‘Where did you grow up? the reporter would ask.’”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“‘Suburban Philadelphia’ would be my neat response.”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“‘What school did you attend?’ he’d follow.”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“‘Aftonville High School.’”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“‘Isn’t that the one with the acclaimed Nobel Prize-winning alum?’”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“‘Yup, two of them. And an Israeli prime minister. The sitting president of the United States was my high school graduation speaker,’ I’d say. There’d be no smugness in my tone because that’s not who I am. You know that.”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“The reporter would then ask, ‘Where did you go to college?’”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“I’d say, ‘Houghton University.’”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“Because I don’t fit the stereotype, the reporter would try to make sense of me. ‘Did you have to take out any college loans?’”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“‘Not a cent,’ I’d reply matter-of-factly.”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _vm._v("“‘Were you raised by both of your parents?’ he’d question.”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“‘Yes,’ I’d respond ‘They’re still married after forty years.’”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“But if the reporter were bold enough to go off-script and ask deeper questions, the wrong questions, he’d know the real me. They violated me. The me that has to scream myself into existence every morning, or else I’ll die. The me that might embrace death with open arms. Listen to me, Marley, as I tell you my story.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e2cc89e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Frontmatter02.vue
// module id = 72
// module chunks = 0